module.exports = __webpack_public_path__ + "static/img/6.d98ca6e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/3/zh/6.png
// module id = Uxch
// module chunks = 0